import React, { useEffect, useState } from 'react';
import { getPlannerSessions } from '../services/plannerSessionService';
import PlannerSessionForm from '../components/PlannerSessionForm';

export default function IdeaExplorerView() {
  const [sessions, setSessions] = useState([]);

  const refresh = async () => {
    try {
      const data = await getPlannerSessions();
      setSessions(data);
    } catch (err) {
      alert("Failed to load sessions.");
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <div>
      <h2>Idea Explorer</h2>
      <PlannerSessionForm onSuccess={refresh} />
      {sessions.map(s => (
        <div key={s.session_id} className="mb-2 border p-2">
          <strong>{s.proposed_change_name}</strong><br />
          <small>{s.session_id}</small><br />
          <em>{new Date(s.last_updated).toLocaleString()}</em>
        </div>
      ))}
    </div>
  );
}
